import { shallow } from "zustand/shallow";
import { createWithEqualityFn } from "zustand/traditional";

type PromotionModalId = "trial_extension_on_purchase";

interface UiStateValues {
  promotionRedeemedModalId: PromotionModalId | null;
}

interface UiState extends UiStateValues {
  setPromotionRedeemedModalId: (id: PromotionModalId | null) => void;
}

const DEFAULT_STATE: UiStateValues = {
  promotionRedeemedModalId: null,
};

const useUiStore = createWithEqualityFn<UiState>(
  (set) => ({
    ...DEFAULT_STATE,
    setPromotionRedeemedModalId: (promotionRedeemedModalId) =>
      set({ promotionRedeemedModalId }),
  }),
  shallow
);

export default useUiStore;
